import React from "react";
import { Handshake } from "@phosphor-icons/react";

const CircleFeature = ({
  icon: Icon = Handshake,
  title = "",
  description = "",
  colorClass = "stroke-[#F79E4C]",
  iconColorClass = "text-[#F79E4C]",
  thickArcOnTop = false,
  descriptionClassName = "max-w-[215px]",
}) => (
  <div className="relative flex flex-col items-center justify-center w-[285px] h-[285px]">
    {/* SVG container */}
    <svg
      className="absolute inset-0"
      viewBox="0 0 285 285"
      width="285"
      height="285"
    >
      {thickArcOnTop ? (
        <>
          {/* Top semi-circle - thick */}
          <path
            d="M10 137 A132.5 122 0 1 1 275 137"
            className={colorClass}
            strokeWidth="12"
            fill="none"
            strokeLinecap="round"
          />

          {/* Bottom semi-circle - thin */}
          <path
            d="M10 148 A132.5 122 0 0 0 275 148"
            className={colorClass}
            strokeWidth="3"
            strokeLinecap="round"
            fill="none"
          />
        </>
      ) : (
        <>
          {/* Top semi-circle - thin */}
          <path
            d="M10 137 A132.5 122 0 1 1 275 137"
            className={colorClass}
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
          />

          {/* Bottom semi-circle - thick */}
          <path
            d="M10 148 A132.5 122 0 0 0 275 148"
            className={colorClass}
            strokeWidth="12"
            strokeLinecap="round"
            fill="none"
          />
        </>
      )}
    </svg>

    {/* Center content */}
    <div className="relative flex flex-col items-center text-center px-4">
      <Icon size={50} className={`${iconColorClass} mb-2`} />
      <h3 className="font-bold text-sm font-montserrat">{title}</h3>
      <p className={`!text-sm mt-2 font-montserrat ${descriptionClassName}`}>
        {description}
      </p>
    </div>
  </div>
);

export default CircleFeature;
